import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  sendGridTemplates: []
}

const getters = {
  getSendGridTemplates: state => state.sendGridTemplates
}

const actions = {
  async fetchSendGridTemplates ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.sendGrid.fetchTemplates())
      commit(types.SET_SEND_GRID_TEMPLATES, data)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to load sand grid templates')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_SEND_GRID_TEMPLATES] (state, templates) {
    state.sendGridTemplates = templates
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sendGrid.js